import { Injectable } from '@angular/core';

@Injectable()
export class RxUploadService {
  constructor() {}

  transform(data) {
    const arr = <any>[];
    const transformArr = [...data];

    transformArr.map((element) => {
      const formData = new FormData();
      formData.append('file', element);
      arr.push(formData);
    });

    return arr;
  }

  setFormData() {}

  // encodeImageFileAsURL(element) {
  //   var file = element.files[0];
  //   var reader = new FileReader();
  //   reader.onloadend = function() {
  //     console.log('RESULT', reader.result)
  //   }
  //   reader.readAsDataURL(file);
  //   return reader.result
  // }
}
